import { debounce } from 'debounce';

// endpoint where search data comes from
const collectionsSearchURL = window.collectionsSearchEndpoint.toString() + (window.collectionsSearchEndpoint.toString().indexOf('?') > -1 ? '&q=' : '?q=');

// Get from the cache, or make a new fetch request
async function getSearchResults(searchString) {
    return await (await window.fetch(collectionsSearchURL + searchString)).text();
}

class CollectionsSearch {

    constructor(el) {
        this.el = el;
        this.searchTextField = el.querySelector('input[type="search"]');
        this.searchWatch = null;
        this.searchText = '';
        this.prevSearchText = '';
        this.resultsWrapper = el.querySelector('.collections-search-form--results');
        this.resultsActive = false;
        // watch the searchTextField
        if(this.searchTextField != null) {
            this.searchTextField.onfocus = () => {
                this.watchSearchText(true);
            };
            this.searchTextField.onblur = () => {
                this.watchSearchText(false);
            };
        }
    }

    watchSearchText(mode) {
        // search only kicks in if text is at least 3 chars
        if(mode) {
            this.searchWatch = setInterval(() => {
                this.checkSearchText(true);
            }, 200);
        } else {
            clearInterval(this.searchWatch);
            this.searchWatch = null;
        }
    }

    checkSearchText(triggerUpdate = false) {
        this.prevSearchText = this.searchText;
        let getSearchText = this.searchTextField.value.toLowerCase().trim(),
            workSearchText = getSearchText.length > 2 ? getSearchText : '';
        if(workSearchText != this.prevSearchText) {
            this.searchText = workSearchText;
            if(triggerUpdate) debounce(this.update(), 200);
        }
    }

    update() {
        if(this.searchText != '') {
            getSearchResults(this.searchText).then((content) => {
                if(content != '') {
                    this.resultsWrapper.innerHTML = content;
                    this.resultsWrapper.setAttribute('aria-hidden','false');
                    this.resultsActive = true;
                } else {
                    this.resultsWrapper.innerHTML = '';
                    this.resultsWrapper.setAttribute('aria-hidden','true');
                    this.resultsActive = false;
                }
            });
        } else {
            this.resultsWrapper.innerHTML = '';
            this.resultsWrapper.setAttribute('aria-hidden','true');
            this.resultsActive = false;
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new CollectionsSearch(node);
        }
    });
}